import {
  R_STATISTICAL_PROGRAMMING,
  R_CLINICAL_DATA_MANAGEMENT,
  R_MEDICAL_WRITING,
  R_REGULAR_AFFAIRS,
} from '@/router/routes';
import statisticalProgrammingDesc from '@/constants/service/descriptions/statisticalProgramming';
import clinicalDataManagementDesc from '@/constants/service/descriptions/clinicalDataManagement';
import medicalWritingDesc from '@/constants/service/descriptions/medicalWriting';
import regulatoryAffairsDesc from '@/constants/service/descriptions/regulatoryAffairs';

export default [
  {
    routeName: R_STATISTICAL_PROGRAMMING,
    component: 'StatisticalProgramming',
    subtitle: 'From Complex Medical Data to Helpful & Intelligible Statistics for a Better Global Health System',
    imgSrc: '/assets/images/services/withoutBg/statisticalProgramming.svg',
    desc: statisticalProgrammingDesc,
  },
  {
    routeName: R_CLINICAL_DATA_MANAGEMENT,
    component: 'ClinicalDataManagement',
    subtitle: 'Generate only reliable, high-quality, and statistically precise data from your clinical trials',
    imgSrc: '/assets/images/services/withoutBg/clinicalDataManagement.svg',
    desc: clinicalDataManagementDesc,
  },
  {
    routeName: R_MEDICAL_WRITING,
    component: 'MedicalWriting',
    subtitle: 'The accuracy of regulatory documents throughout all stages of the drug development process',
    imgSrc: '/assets/images/services/withoutBg/medicalWriting.svg',
    desc: medicalWritingDesc,
  },
  {
    routeName: R_REGULAR_AFFAIRS,
    component: 'RegulatoryAffairs',
    subtitle: 'Have Your Regulatory Submissions Approved Smoothly While Meeting All the Ethical Standards',
    imgSrc: '/assets/images/services/withoutBg/regulatoryAffairs.svg',
    desc: regulatoryAffairsDesc,
  },
];
